import React from 'react';
import { Switch, Route } from 'react-router-dom';
import withOnboarding from './withOnboarding';
import OnboardingStep from './OnboardingStep';

class OnboardingSteps extends React.Component {
  state = {
    steps: []
  };

  render() {
    const { steps } = this.state;
    return (
      <Switch>
        {steps.map(
          ({ mainComponent, mainProps = {}, step, path, ...rest }, index) => (
            <Route
              key={index}
              exact
              path={path}
              render={() => (
                <OnboardingStep
                  step={step}
                  path={path}
                  Component={mainComponent}
                  {...mainProps}
                />
              )}
            />
          )
        )}
      </Switch>
    );
  }

  static getDerivedStateFromProps(props, state) {
    const derivedState = {
      steps: []
    };

    React.Children.toArray(props.children).forEach((child, i) => {
      derivedState.steps.push({ ...child.props });
    });

    return derivedState;
  }

  componentDidMount() {
    this.props.actions.initSteps(this.state.steps);
  }
}
export default withOnboarding(OnboardingSteps);



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingSteps.js